const messages = {
  en: {
    start: 'Get started with the'
  },
  'es-ud': {
    start: 'Empiece a usar el'
  },
  es: {
    start: 'Empieza a usar el'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/GettingStartedNavLink/messages.js